"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiTooltip = getMuiTooltip;
function getMuiTooltip(palette) {
  return {
    styleOverrides: {
      arrow: {
        '&.MuiTooltip-arrow': {
          '&::before': {
            background: palette.common.white
          }
        }
      },
      tooltip: {
        '&.MuiTooltip-tooltip': {
          background: palette.common.white,
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: '22px'
        },
        borderRadius: '4px',
        color: palette.grey[800],
        filter: 'drop-shadow(0px 2px 6px rgba(51, 51, 51, 0.15))',
        padding: '4px 8px'
      }
    }
  };
}